<template>
  <pt-detection-corpus-table class="pt-detection-corpus-table__withData" ref="table" :request-data="getDataList" :page-size="pageSize"
  :total-number="Number(totalNumber)" :table-data="tableData" :tableLabels="tableLabels"  :isOutside="isOutside">
  <template slot-scope="scope">
      <slot :row="scope.row"></slot>
    </template>
  </pt-detection-corpus-table>
</template>

<script>
import PtDetectionCorpusTable from './index'
export default {
  name: 'pt-detection-corpus-table__withData',
  components: {
    'pt-detection-corpus-table': PtDetectionCorpusTable
  },
  data () {
    return {
      pageSize: 10,
      totalNumber: 0,
      tableData: [],
      currentParams: {},
      isOutside: false
    }
  },
  props: {
    tableLabels: {
      type: Array,
      default: () => []
    },
    paramsData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isFromRouter: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        if (!this.isFromRouter) {
          this.currentParams = val
          this.resetPage()
        } else {
          this.isOutside = true
          this.currentParams = val
          this.getDataList(this.page)
        }
        // this.currentParams = val
        // this.getDataList(0)
      },
      deep: true
    }
  },
  methods: {
    resetPage () {
      this.$refs.table.resetPage()
    },
    getDataList (page, next) {
      let data = {
        page: page,
        size: this.pageSize,
        sort: 'id,desc',
        ...this.currentParams
      }
      this.$store.dispatch('getDetectionCorpusList', data).then(res => {
        if (next) {
          next(res.data)
        }
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        this.$emit('getAllSize', this.totalNumber)
      }).catch(err => {
        this.$refs.table.showReTry()
        this.$message.error(err)
      })
    },
    // 筛选数据的参数,不传默认为{}
    reload (params = {}) {
      this.currentParams = params
      this.$refs.table.reload()
    }
  }
}
</script>
